import React, { useState, useEffect } from 'react';
import Input from '../common/Input';
import Button from '../common/Button';
import { HANDICAP_RANGE } from '../../utils/constants';

export default function PlayerForm({ player = null, onSubmit, onCancel, isLoading = false }) {
  const [formData, setFormData] = useState({
    name: '',
    handicap: 10,
    series: 'both'
  });

  const [errors, setErrors] = useState({});

  // Populate form if editing
  useEffect(() => {
    if (player) {
      setFormData({
        name: player.name || '',
        handicap: player.handicap || 10,
        series: player.series || 'both'
      });
    }
  }, [player]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'handicap' ? parseInt(value) || 0 : value
    }));

    // Clear error for this field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    } else if (formData.name.length < 2) {
      newErrors.name = 'Name must be at least 2 characters';
    }

    if (formData.handicap < HANDICAP_RANGE.MIN) {
      newErrors.handicap = `Handicap must be at least ${HANDICAP_RANGE.MIN}`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      onSubmit(formData);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Input
        label="Player Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        error={errors.name}
        placeholder="Enter player name"
        required
        autoFocus
      />

      <Input
        label="Handicap"
        name="handicap"
        type="number"
        min={HANDICAP_RANGE.MIN}
        value={formData.handicap}
        onChange={handleChange}
        error={errors.handicap}
        required
      />

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Plays In</label>
        <select
          name="series"
          value={formData.series}
          onChange={handleChange}
          className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="both">TML & FriDave</option>
          <option value="tml">TML only</option>
          <option value="fridave">FriDave only</option>
          <option value="open">The Clubhouse only (guest)</option>
        </select>
        <p className="text-xs text-gray-500 mt-1">
          Guest players are kept out of the TML and FriDave player lists.
        </p>
      </div>

      <div className="flex gap-3 mt-6">
        <Button
          type="button"
          variant="secondary"
          onClick={onCancel}
          disabled={isLoading}
          className="flex-1"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="primary"
          disabled={isLoading}
          className="flex-1"
        >
          {isLoading ? 'Saving...' : player ? 'Update Player' : 'Create Player'}
        </Button>
      </div>
    </form>
  );
}
